import useTonnageFilterSeed from 'hooks/use-tonnage-filter-seed';

export default function TonnageFilterSeedWatcher() {
  useTonnageFilterSeed();
  return null;
}
